import { render, staticRenderFns } from "./chemicalBuyMine.vue?vue&type=template&id=021ce4f9&scoped=true"
import script from "./chemicalBuyMine.vue?vue&type=script&lang=js"
export * from "./chemicalBuyMine.vue?vue&type=script&lang=js"
import style0 from "./chemicalBuyMine.vue?vue&type=style&index=0&id=021ce4f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ce4f9",
  null
  
)

export default component.exports